import pdfiumWasmUrlRaw from '@embedpdf/pdfium/pdfium.wasm?url';

// Vite's `?url` returns a path-relative URL. The pdfium worker runs from a
// `blob:` URL and can't resolve path-relative URLs against its blob base, so we
// absolutize against the page origin before passing it in.
export const pdfiumWasmUrl = new URL(pdfiumWasmUrlRaw, window.location.origin).toString();
